import { render, staticRenderFns } from "./StationMsg.vue?vue&type=template&id=22460336&scoped=true"
import script from "./StationMsg.vue?vue&type=script&lang=js"
export * from "./StationMsg.vue?vue&type=script&lang=js"
import style0 from "./StationMsg.vue?vue&type=style&index=0&id=22460336&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22460336",
  null
  
)

export default component.exports